<div class="logo-container">
  <img src="assets/finspire-logo-redesign.webp" alt="finspire" fetchpriority="high" width="160" height="40">
</div>
